define.alias("shared/utils/insert-text-at-cursor", "settings/utils/insert-text-at-cursor");